import { Entite } from './../../z16pro/classes/entite';
import { AlertService } from './alert.service';
import { Injectable, EventEmitter } from '@angular/core';
import { Bureau } from '../../core/shared/classes/bureau';
import { NavStorage } from '../classes/nav-storage';
import { Pays } from '../classes/pays';
import { Batiment } from '../../infrastructure/shared/classes/batiment';
import { Role } from '../../identite/shared/classes/role';
import { ConfigurationClient } from '../../core/shared/classes/configuration-client';
import { BehaviorSubject } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { IBatimentLotSort } from '../../infrastructure/shared/classes/batiment-lot-sort';
import { IMultipleSort } from '../../infrastructure/shared/classes/multiple-sort';

@Injectable()
export class StorageService {

    typeVersion = 'lu';
    pays: Pays = null;
    selectedRdvId: string;
    apiUrl: string;
    subdomain: string;
    logoEvent: EventEmitter<any>;
    bureauxEvent: EventEmitter<any>;
    typeVersionEvent: EventEmitter<string>;
    paysEvent: EventEmitter<Pays>;
    bureaux: Bureau[];
    batiments: Batiment[];
    maitres: Role[];
    lstAcl: any[];
    aclEvent: EventEmitter<any>;
    configuration: any;
    userConfigurations: Array<any>;
    z16ProEntites: Entite[];
    z16ProEntiteEvent: EventEmitter<Entite[]>;
    navStorage: NavStorage;
    configurationClientSub: BehaviorSubject<ConfigurationClient>;

    public cache: Map<String, HttpResponse<any>> = new Map()

    private _configurationClient: ConfigurationClient;

    constructor(
        private alertService: AlertService
    ) {
        this.logoEvent  = new EventEmitter();
        this.aclEvent   = new EventEmitter();
        this.typeVersionEvent = new EventEmitter();
        this.paysEvent = new EventEmitter();
        this.z16ProEntiteEvent = new EventEmitter();
        this.navStorage = new NavStorage(this.alertService);
        if (localStorage.getItem('configuration_client')) {
            this._configurationClient = new ConfigurationClient(JSON.parse(localStorage.getItem('configuration_client')));
            this.configurationClientSub = new BehaviorSubject<ConfigurationClient>(this._configurationClient);
        } else {
            this.configurationClientSub = new BehaviorSubject<ConfigurationClient>(new ConfigurationClient());
        }
    }

    clearCache(key?: string) {
        if (key) {
            this.cache.delete(key)
        } else {
            this.cache = new Map()
        }
    }

    setBureaux(bureaux: Bureau[]) {
        this.bureaux = bureaux;
    }

    getBureaux() {
        return this.bureaux ? this.bureaux : [];
    }

    setMaitres(maitres: Role[]) {
         this.maitres = maitres;
    }

    getMaitres() {
        return this.maitres ? this.maitres : [];
    }

    setBatiments(batiments: Batiment[]) {
        this.batiments = batiments;
    }

    getBatiments() {
        return this.batiments ? this.batiments : [];
    }

    setTypeVersion(version: string) {
        this.emitTypeVersionEvent(version);
        this.typeVersion = version;
    }

    emitTypeVersionEvent(typeVersion: string) {
        this.typeVersionEvent.emit(typeVersion);
    }

    getTypeVersion() {
        return this.typeVersion;
    }

    setPays(pays: any) {
        if (!pays) {
            return;
        }
        const pay = new Pays(pays);
        this.emitPaysEvent(pay);
        this.pays = pay;
    }

    emitPaysEvent(pays: Pays) {
        this.paysEvent.emit(pays);
    }

    getPays() {
        return this.pays;
    }

    setSelectedRdvId(id: string) {
        this.selectedRdvId = id;
    }

    getSelectedRdvId() {
        return this.selectedRdvId;
    }

    getLogoUrl() {
        return this.apiUrl + 'clients/' + this.subdomain + '/';
    }

    getVideoUrl(): string {
        return this.apiUrl + 'video/';
    }

    getApiUrl(): string {
        return this.apiUrl;
    }

    setApiUrl(url: string): void {
        this.apiUrl = url;
    }

    getSubdomain() {
        return this.subdomain;
    }

    setSubdomain(subdomain: string) {
        this.subdomain = subdomain;
    }

    setAcl(lstAcl: any, sendEvent: boolean = true) {
        this.lstAcl = lstAcl;
        if (sendEvent) {
            this.emitAclEvent();
        }
    }

    getAcl(acl_id?: string) {
        if (!this.lstAcl) {
            this.lstAcl = JSON.parse(localStorage.getItem('acl'));
        }

        if (this.lstAcl) {
            return acl_id && this.lstAcl[acl_id] ? this.lstAcl[acl_id] : this.lstAcl;
        }

        return [];
    }

    emitAclEvent() {
        this.aclEvent.emit(this.lstAcl);
    }

    setConfiguration(data: any) {
        this.configuration = data;
    }

    setSpecificConfiguration(data: any) {
        for (const key in data) {
            if (data.hasOwnProperty(key) && this.configuration[key] !== undefined) {
                this.configuration[key] = data[key];
            }
        }
    }

    getConfiguration() {
        return this.configuration;
    }

    setUserConfigurations(data: any) {
        this.userConfigurations = data;
    }

    getUserConfigurations() {
        if (this.userConfigurations == null) {
            this.userConfigurations = JSON.parse(localStorage.getItem('userConfigurations')) || [];
        }
        return this.userConfigurations;
    }

    setZ16ProEntite(entites: Entite[]) {
        this.z16ProEntites = entites;
        this.z16ProEntiteEvent.emit(this.z16ProEntites);
    }

    getZ16ProEntite() {
        return this.z16ProEntites ? this.z16ProEntites : [];
    }

    set configurationClient(configurationClient) {
        this._configurationClient = configurationClient;
        this.configurationClientSub.next(this._configurationClient);
    }

    get configurationClient(): ConfigurationClient {
        return this._configurationClient;
    }

    setSortBatimentDetailLots(sortBatimentDetailLots: IBatimentLotSort[]) {
        sessionStorage.setItem('sortBatimentDetailLots', JSON.stringify(sortBatimentDetailLots));
    }

    getSortBatimentDetailLots() {
        return JSON.parse(sessionStorage.getItem('sortBatimentDetailLots'));
    }

    setSortBatimentDetailPackages(sortBatimentDetailPackages: IBatimentLotSort[]) {
        sessionStorage.setItem('sortBatimentDetailPackages', JSON.stringify(sortBatimentDetailPackages));
    }

    getSortBatimentDetailPackages() {
        return JSON.parse(sessionStorage.getItem('sortBatimentDetailPackages'));
    }

    setBatimentDetailSortedLotsIds(batimentDetailSortedLotsIds: string[]) {
        sessionStorage.setItem('batimentDetailSortedLotsIds', JSON.stringify(batimentDetailSortedLotsIds));
    }

    getBatimentDetailSortedLotsIds() {
        return JSON.parse(sessionStorage.getItem('batimentDetailSortedLotsIds'));
    }

    setSortFactures(sortFactures: IMultipleSort[]) {
        sessionStorage.setItem('sortFactures', JSON.stringify(sortFactures));
    }

    getSortFactures() {
        return JSON.parse(sessionStorage.getItem('sortFactures'));
    }

    setFacturesSortedIds(facturesSortedIds: string[]) {
        sessionStorage.setItem('facturesSortedIds', JSON.stringify(facturesSortedIds));
    }

    getFacturesSortedIds() {
        return JSON.parse(sessionStorage.getItem('facturesSortedIds'));
    }
}
